module.exports = __webpack_public_path__ + "img/butterfly.1dd01237.png";